if (!customElements.get('display-case-upsell')) {
  customElements.define(
    'display-case-upsell',
    class DisplayCaseUpsell extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onVariantClick = this.onVariantClick.bind(this);
        this.onFigureQuantityChange = this.onFigureQuantityChange.bind(this);
        this.onDisplayCaseQuantityChange = this.onDisplayCaseQuantityChange.bind(this);
        this.quantityLinked = true;
      }

      connectedCallback() {
        this.hiddenInput = this.querySelector('[data-display-case-variant-input]');
        this.totalEl = this.querySelector('[data-display-case-total]');
        this.quantityRow = this.querySelector('[data-display-case-quantity-row]');
        this.quantityInput = this.querySelector('[data-display-case-quantity]');
        this.figurePrice = parseInt(this.dataset.figurePrice, 10) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

        this.querySelectorAll('[data-display-case-option]').forEach((option) => {
          option.addEventListener('change', this.onChange);
        });

        this.querySelectorAll('[data-display-case-variant-select]').forEach((input) => {
          input.addEventListener('change', this.onVariantChange);
          input.addEventListener('click', this.onVariantClick);
        });

        this.quantityInput?.addEventListener('change', this.onDisplayCaseQuantityChange);
        this.quantityInput?.addEventListener('input', this.onDisplayCaseQuantityChange);

        this.figureQuantityInput = document.querySelector(
          `#${CSS.escape(this.dataset.productFormId)} [name="quantity"]`
        );
        this.figureQuantityInput?.addEventListener('change', this.onFigureQuantityChange);
        this.figureQuantityInput?.addEventListener('input', this.onFigureQuantityChange);

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            if (event.data.variant?.price != null) {
              this.setFigurePrice(event.data.variant.price);
            }
          });
        }

        this.syncQuantityVisibility();
        this.syncVariantPanels();
        this.syncHiddenInput();
        this.updateTotal();
        this.updateSelectedPrices();
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-display-case-option]').forEach((option) => {
          option.removeEventListener('change', this.onChange);
        });
        this.querySelectorAll('[data-display-case-variant-select]').forEach((input) => {
          input.removeEventListener('change', this.onVariantChange);
          input.removeEventListener('click', this.onVariantClick);
        });
        this.quantityInput?.removeEventListener('change', this.onDisplayCaseQuantityChange);
        this.quantityInput?.removeEventListener('input', this.onDisplayCaseQuantityChange);
        this.figureQuantityInput?.removeEventListener('change', this.onFigureQuantityChange);
        this.figureQuantityInput?.removeEventListener('input', this.onFigureQuantityChange);
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      getSelectedOption() {
        return this.querySelector('[data-display-case-option]:checked');
      }

      getFigureQuantity() {
        const qtyInput = document.querySelector(`#${CSS.escape(this.dataset.productFormId)} [name="quantity"]`);
        return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      }

      getDisplayCaseQuantity() {
        if (!this.quantityInput) return 1;
        return Math.max(1, parseInt(this.quantityInput.value, 10) || 1);
      }

      getSelectedVariantId() {
        const selected = this.getSelectedOption();
        if (!selected || !selected.value) return '';

        const variantInput = this.querySelector(
          `[data-display-case-variants][data-product-id="${selected.value}"] [data-display-case-variant-select]:checked:not(:disabled)`
        );
        if (variantInput) return variantInput.value;
        return selected.dataset.variantId || '';
      }

      getSelectedCasePrice() {
        const selected = this.getSelectedOption();
        if (!selected || !selected.value) return 0;
        const variantId = this.getSelectedVariantId();
        if (!variantId) return 0;

        const variantInput = this.querySelector(
          `[data-display-case-variant-select][value="${variantId}"]`
        );
        if (variantInput) return parseInt(variantInput.dataset.price, 10) || 0;
        return parseInt(selected.dataset.variantPrice, 10) || 0;
      }

      syncQuantityVisibility() {
        const selected = this.getSelectedOption();
        const hasCase = Boolean(selected?.value);

        if (this.quantityRow) {
          this.quantityRow.hidden = !hasCase;
        }

        if (hasCase && this.quantityLinked) {
          this.setDisplayCaseQuantity(this.getFigureQuantity(), false);
        }
      }

      setDisplayCaseQuantity(quantity, markUnlinked = false) {
        if (!this.quantityInput) return;
        const nextQuantity = Math.max(1, quantity);
        this.quantityInput.value = nextQuantity;
        if (markUnlinked) {
          this.quantityLinked = false;
        }
      }

      syncVariantPanels() {
        const selected = this.getSelectedOption();
        this.querySelectorAll('[data-display-case-variants]').forEach((panel) => {
          panel.classList.remove('is-active');
        });

        if (!selected?.value) return;

        const panel = this.querySelector(
          `[data-display-case-variants][data-product-id="${selected.value}"]`
        );
        if (!panel) return;

        panel.classList.add('is-active');

        let checked = panel.querySelector('[data-display-case-variant-select]:checked:not(:disabled)');
        if (!checked) {
          checked = panel.querySelector('[data-display-case-variant-select]:not(:disabled)');
          if (checked) checked.checked = true;
        }
      }

      syncHiddenInput() {
        if (!this.hiddenInput) return;
        const variantId = this.getSelectedVariantId();
        this.hiddenInput.value = variantId;
        this.hiddenInput.disabled = !variantId;
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return this.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }

      updateSelectedPrices() {
        this.querySelectorAll('[data-display-case-card]').forEach((card) => {
          const priceEl = card.querySelector('[data-display-case-price]');
          const productId = card.querySelector('[data-display-case-option]')?.value;
          if (!priceEl || !productId) return;

          const variantInput = this.querySelector(
            `[data-display-case-variants][data-product-id="${productId}"] [data-display-case-variant-select]:checked`
          );
          if (!variantInput) return;

          const price = parseInt(variantInput.dataset.price, 10);
          if (!Number.isNaN(price)) {
            priceEl.textContent = `+${this.formatMoney(price)}`;
          }
        });
      }

      updateTotal() {
        if (!this.totalEl) return;
        const casePrice = this.getSelectedCasePrice();
        if (!casePrice) {
          this.totalEl.hidden = true;
          return;
        }

        const figureQuantity = this.getFigureQuantity();
        const displayCaseQuantity = this.getDisplayCaseQuantity();
        const combined = this.figurePrice * figureQuantity + casePrice * displayCaseQuantity;

        this.totalEl.innerHTML = this.dataset.totalTemplate
          .replace('__TOTAL__', this.formatMoney(combined))
          .replace('__CASE__', this.formatMoney(casePrice * displayCaseQuantity))
          .replace('__QTY__', String(displayCaseQuantity));
        this.totalEl.hidden = false;
      }

      onChange() {
        const selected = this.getSelectedOption();
        if (selected?.value) {
          this.quantityLinked = true;
          this.setDisplayCaseQuantity(this.getFigureQuantity(), false);
        }
        this.syncQuantityVisibility();
        this.syncVariantPanels();
        this.syncHiddenInput();
        this.updateTotal();
      }

      onFigureQuantityChange() {
        if (this.quantityLinked && this.getSelectedOption()?.value) {
          this.setDisplayCaseQuantity(this.getFigureQuantity(), false);
        }
        this.updateTotal();
      }

      onDisplayCaseQuantityChange() {
        this.quantityLinked = false;
        this.updateTotal();
      }

      onVariantClick(event) {
        const panel = event.target.closest('[data-display-case-variants]');
        const productId = panel?.dataset.productId;
        if (!productId) return;

        const radio = this.querySelector(`[data-display-case-option][value="${productId}"]`);
        if (radio && !radio.disabled && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onVariantChange() {
        this.syncVariantPanels();
        this.updateSelectedPrices();
        this.syncHiddenInput();
        this.updateTotal();
      }

      setFigurePrice(cents) {
        this.figurePrice = cents;
        this.updateTotal();
      }

      getQuantityForCart() {
        if (!this.getSelectedVariantId()) return 0;
        return this.getDisplayCaseQuantity();
      }
    }
  );
}
